import React from 'react';

const ErrorBanner = ({ children }) => {
	if (!children) return null;

	return (
		<div className="w-full rounded-[10px] bg-pay-error-bg px-[14px] py-[10px] text-[13px] text-pay-error">
			{children}
		</div>
	);
};

export default ErrorBanner;
